import React, { createContext, useContext, useState, ReactNode } from 'react';

interface BackgroundColorContextType {
    backgroundColor: string | undefined;
    setBackgroundColor: (color: string | undefined) => void;
}

const BackgroundColorContext = createContext<BackgroundColorContextType | undefined>(undefined);

export const BackgroundColorProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [backgroundColor, setBackgroundColor] = useState<string | undefined>('#000');

    return (
        <BackgroundColorContext.Provider value={{ backgroundColor, setBackgroundColor }}>
            {children}
        </BackgroundColorContext.Provider>
    );
};

export const useBackgroundColor = (): BackgroundColorContextType => {
    const context = useContext(BackgroundColorContext);
    if (!context) {
        throw new Error('useBackgroundColor must be used within a BackgroundColorProvider');
    }
    return context;
};
